export var getPlayersTokenFromCompany = function (companyID, players) {
    var player = players.find(function (player) { return player.companyID === companyID; });
    return player ? player.token : null;
};
